import React from 'react';
import { Date as DateIcon, Plus, Delete } from '../Icons/CustomIcons';

/*
 * Editor fuer eine Liste von Datumsbereichen ({ from, until }).
 * Spiegelt das "Datum hinzufuegen" / "Loeschen"-Muster der Einzeltermine
 * (single_event) wider und wird fuer regular_hours, recurring_event und
 * freely_accessible verwendet, um z.B. Schulferien abzubilden.
 *
 * labelFrom/labelUntil sind die Basis-Beschriftungen ohne "(optional)".
 * Ob ein Feld optional ist, ergibt sich pro Zeile aus der Verkettungsregel:
 * - "ab" ist Pflicht ab dem 2. Zeitraum sowie im 1. Zeitraum, wenn
 *   fromRequired gesetzt ist (mehrwoechige Wiederholungen).
 * - "bis" ist Pflicht in allen Zeitraeumen ausser dem letzten.
 */
const DateRangeListEditor = ({
  ranges,
  onChange,
  labelFrom = 'Gültig ab',
  labelUntil = 'Gültig bis',
  fromRequired = false,
}) => {
  // Always show at least one (empty) row so the user can start entering data.
  const list = ranges && ranges.length > 0 ? ranges : [{ from: '', until: '' }];

  const labelText = (base, required) => `${base}${required ? ' *' : ' (optional)'}`;

  const handleAdd = () => onChange([...list, { from: '', until: '' }]);

  const handleRemove = (index) => {
    onChange(list.length > 1 ? list.filter((_, i) => i !== index) : [{ from: '', until: '' }]);
  };

  const handleChange = (index, field, value) => {
    onChange(list.map((r, i) => (i === index ? { ...r, [field]: value } : r)));
  };

  return (
    <div className="date-range-list">
      {list.map((range, index) => (
        <div key={index} className="single-event-date-group">
          <div className="single-event-date-header">
            <h3 className="icon-header">
              <span className="icon-wrap"><DateIcon size={20} color="#fff" /></span>
              {list.length > 1 ? `Zeitraum ${index + 1}` : 'Zeitraum'}
            </h3>
            <div className="single-event-date-actions">
              {list.length > 1 && (
                <button
                  type="button"
                  className="Font-M-I-130-T btn-remove-time"
                  onClick={() => handleRemove(index)}
                >
                  <Delete size={18} />
                  Löschen
                </button>
              )}
            </div>
          </div>
          <div className="start-end-time">
            <div className="start-end-time--inner">
              <label className="body Font-M-I-130-T Colors-Black start-end-time--label">
                {labelText(labelFrom, index > 0 || fromRequired)}
              </label>
              <input
                type="date"
                value={range.from || ''}
                onChange={(e) => handleChange(index, 'from', e.target.value)}
                className="input text__input"
              />
            </div>
            <div className="start-end-time--inner">
              <label className="body Font-M-I-130-T Colors-Black start-end-time--label">
                {labelText(labelUntil, index < list.length - 1)}
              </label>
              <input
                type="date"
                value={range.until || ''}
                onChange={(e) => handleChange(index, 'until', e.target.value)}
                className="input text__input"
              />
            </div>
          </div>
        </div>
      ))}
      <button
        type="button"
        className="Font-M-I-130-T btn-add-time-full"
        onClick={handleAdd}
      >
        <Plus size={20} />
        Datum hinzufügen
      </button>
    </div>
  );
};

export default DateRangeListEditor;
